<div class="asset-header">
  <div class="asset-header--container">
    <!-- Leaf Pattern Decoration -->
    <div class="asset-header--leaf-pattern">
      <img src="/assets-leaf.png" alt="" class="asset-header--leaf-image" />
    </div>
    
    <!-- Title and Description -->
    <div class="asset-header--content">
      <div class="asset-header--text">
        <!-- Breadcrumbs -->
        <nav class="asset-header--breadcrumbs" *ngIf="config.breadcrumbs && config.breadcrumbs.length > 0">
          <ol class="breadcrumbs--list">
            <li class="breadcrumbs--item" *ngFor="let crumb of config.breadcrumbs; let first = first">
              <a [routerLink]="crumb.route" *ngIf="crumb.route; else noLink" class="breadcrumbs--link">
                <img *ngIf="first && crumb.label === 'Home'" src="/home.svg" alt="Home" class="breadcrumbs--home-icon" />
                <span *ngIf="!(first && crumb.label === 'Home')" class="breadcrumbs--label-truncate" [title]="crumb.label">{{ crumb.label }}</span>
              </a>
              <ng-template #noLink>
                <span class="breadcrumbs--current breadcrumbs--label-truncate" [title]="crumb.label">{{ crumb.label }}</span>
              </ng-template>
            </li>
          </ol>
        </nav>
        <div class="asset-header--title-wrapper">
          <div class="asset-header--title-group">
            <h3 class="asset-header--title" [title]="config.title">{{ config.title }}</h3>
          </div>
          
          <div class="asset-header--actions" *ngIf="showActions || config.assetId">
            <!-- Copy Button -->
            <button 
              *ngIf="config.assetId" 
              class="asset-header--action-btn"
              (click)="copyAssetId()"
              [attr.aria-label]="'Copy asset ID'"
              [title]="copySuccess ? 'Copied!' : 'Copy asset ID'"
            >
              <svg class="asset-header--action-icon asset-header--copy-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="asset-header--copy-success" *ngIf="copySuccess">Copied!</span>
            </button>
            <!-- Like Button (heart icon) -->
            <button 
              *ngIf="showActions && showLikeButton"
              class="asset-header--action-btn"
              [class.active]="isLiked"
              (click)="onLikeClick()"
              [attr.aria-label]="isLiked ? 'Unlike this asset' : 'Like this asset'"
              [title]="isLiked ? 'Unlike' : 'Like'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--like-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" 
                  [attr.fill]="isLiked ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>
            <!-- Bookmark Button (ribbon bookmark icon) -->
            <button 
              *ngIf="showActions"
              class="asset-header--action-btn"
              [class.active]="isBookmarked"
              (click)="onBookmarkClick()"
              [attr.aria-label]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
              [title]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--bookmark-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" 
                  [attr.fill]="isBookmarked ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Pinned Button (discussions only) – pinned icon -->
            <button 
              *ngIf="showPinButton"
              class="asset-header--action-btn"
              [class.active]="isPinned"
              (click)="onPinClick()"
              [attr.aria-label]="isPinned ? 'Unpin this discussion' : 'Pin this discussion'"
              [title]="isPinned ? 'Unpin this discussion' : 'Pin this discussion'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--pinned-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1.03 1 1.03-1v-7H19v-2c-1.66 0-3-1.34-3-3z" 
                  [attr.fill]="isPinned ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Thumbs up / Upvote (discussion detail only) -->
            <ng-container *ngIf="showVoteButtons">
              <button 
                class="asset-header--action-btn asset-header--vote-btn"
                [class.active]="userVote === 'up'"
                (click)="onUpvoteClick()"
                [attr.aria-label]="userVote === 'up' ? 'Remove upvote' : 'Upvote'"
                [title]="userVote === 'up' ? 'Remove upvote' : 'Upvote'"
              >
                <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg class="asset-header--action-icon asset-header--vote-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22V11" stroke="#059669" [attr.fill]="userVote === 'up' ? '#059669' : 'none'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </ng-container>
          </div>
        </div>
        <p class="asset-header--created-at" *ngIf="config.createdAt">Created at {{ config.createdAt }}</p>
        <p class="asset-header--description" *ngIf="config.description">{{ config.description }}</p>
      </div>
      
      <!-- Decorative Icons -->
      <div class="asset-header--icons" *ngIf="config.iconPath">
        <img [src]="config.iconPath" alt="Decorative icons" class="asset-header--icon-image" />
      </div>
    </div>
  </div>
</div>

